import Vue from 'vue'
import Febs from './FEBS'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'ant-design-vue/dist/antd.css'
import VCharts from 'v-charts'

import filters from './filters';


//vue 高德插件  注：高德原生地图和这个插件会有冲突
import VueAMap from 'vue-amap';



//百度地图
// import BaiduMap from 'vue-baidu-map'


import 'utils/install'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)
Vue.use(VueAMap)
Vue.use(VCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use({
  install(Vue) {
    Vue.prototype.$db = db
  },
})
Vue.use(ElementUI, {
  size: 'small'
});

//main.js里注册自定义的全局过滤器filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'X0p4fcVL5BymoDohkv6bqaISgBu0PTrO'
// })


Vue.prototype.$postJSON = request.postJSON
Vue.prototype.$postMultipart = request.postMultipart
Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$modelDownload = request.modelDownload /*封装的公共方法*/
Vue.prototype.$modelUpLoad = request.modelUpLoad    /*封装的公共方法*/
Vue.prototype.$axios = axios   /*全局注册，使用方法为:this.$axios*/

// Vue.prototype.baseURL = process.env.API_ROOT;
Vue.prototype.qs = qs         //全局注册，使用方法为:this.qs
Vue.prototype.moment = moment 	//全局注册，使用方法为:this.moment	  vue项目中moment的使用（时间戳格式化）

// 添加全局事件监控方法 监控司机位置值的变化配合webSocket  2020.05.16  https://blog.csdn.net/weixin_42505098/article/details/82820174
// Vue.prototype.resetSetItem = function (key, newVal) {
//   if (key === 'driverPositionData') {

//     // 创建一个StorageEvent事件
//     var newStorageEvent = document.createEvent('StorageEvent');
//     const storage = {
//       setItem: function (k, val) {
//         sessionStorage.setItem(k, val);

//         // 初始化创建的事件
//         newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

//         // 派发对象
//         window.dispatchEvent(newStorageEvent)
//       }
//     }
//     return storage.setItem(key, newVal);
//   }
// }


/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(Febs)
}).$mount('#febs')














// WEBPACK FOOTER //
// ./src/main.js